<div class="login-bdp content-without-footer d-flex">
    <app-sprintpay-login class="position-absolute" [widthLogo]="'180'" [heightLogo]="'30'">
        <ng-container login-verbiage>
            <h4 class="mat-subtitle-1 text-center align-self-center">
                To sign in please enter your SprintPay credentials
            </h4>
        </ng-container>
    </app-sprintpay-login>
</div>
